import Pqp from "../../../3x1010/Pqp.js";
import Screen from "../Screen.js";
import Fight from "./Fight.js";
import ItemProviders from "../../items/ItemProviders.js";
import Bout from "../../bout/Bout.js";
import Control from "../controllers/Control.js";

export default class AttackWithWeapon {
	constructor(mc, ref) {
		this.mc = mc;
		this.ref = ref;
		this.mainPattern;
		this.canClick = false;
	}
	init() {
		this.build()
	}

	build() {
		jQuery(".js-swordsmanship", this.mc).hide();
		jQuery(".js-macecombat", this.mc).hide();
		jQuery(".js-fencing", this.mc).hide();
		jQuery(".js-noweapon", this.mc).hide();
		let item = Screen.that.paperdoll.getCurrentWeapon();

		if (item) {
			if (item.weapon_skill === ItemProviders.WEAPON_SKILL_SWORDSMANSHIP) {
				jQuery(".js-swordsmanship", this.mc).show();
				this.mainPattern = 0;
			} else if (item.weapon_skill === ItemProviders.WEAPON_SKILL_MACECOMBAT) {
				jQuery(".js-macecombat", this.mc).show();
				this.mainPattern = 1;
			} else {
				// ItemProviders.WEAPON_SKILL_FENCING
				jQuery(".js-fencing", this.mc).show();
				this.mainPattern = 2;
			}
		} else {
			jQuery(".js-noweapon", this.mc).show();
			this.mainPattern = 3;
		}

		this.indicator = jQuery(".js-indicator", this.mc);
		this.resetIndicator();



	}

	start(enemy, callback) {
		this.enemy = enemy;
		this.callback = callback;
		//setTimeout(this.attackDone.bind(this), 1000);
		let parm = this.getParams();
		this.createRound(parm);
		//this.mc.on("click", this.createRound.bind(this, parm));

	}



	getParams() {
		let lore = this.enemy.mob.lore;
		let herol = Bout.that.player.currentLevel;
		let enemyl = lore.level;

		let diff = enemyl - herol;
		if (diff !== 0) {
			if (diff > 0) {
				if (diff > 2) {
					diff = 2
				}
			} else {
				if (diff > -2) {
					// verde
					diff = -2;
				}
			}
		}
		diff = diff + 2;
		// Da 0 a 4
		//diff = 0;
		let w = jQuery(".js-hits", this.mc).width();
		let piece = w / 8;
		let o = new Object();
		let normal
		let critical
		let time
		if (diff <= 0) {
			normal = piece + piece + piece;
			critical = normal / 4;
			if (this.mainPattern !== 0) {
				critical = normal / 3;
			}
			time = AttackWithWeapon.TIME_WEAKEST;
		} else if (diff === 1) {
			normal = piece + piece + piece / 2;
			critical = normal / 5;
			if (this.mainPattern !== 0) {
				critical = normal / 3;
			}
			time = AttackWithWeapon.TIME_WEAKER;
		} else if (diff === 2) {
			normal = piece + piece;
			critical = normal / 4;
			if (this.mainPattern !== 0) {
				critical = normal / 3;
			}
			time = AttackWithWeapon.TIME_EQUAL;
		} else if (diff === 3) {
			normal = piece + piece / 2;
			critical = normal / 4;
			if (this.mainPattern !== 0) {
				critical = normal / 3;
			}
			time = AttackWithWeapon.TIME_STRONGER;
		} else { // 4
			normal = piece;
			critical = normal / 4;
			if (this.mainPattern !== 0) {
				critical = normal / 3;
			}
			time = AttackWithWeapon.TIME_STRONGESET;
		}
		o.normal = normal;
		o.critical = critical;
		o.time = time;

		if (this.mainPattern !== 3) {
			if (Pqp.check(0.8)) {
				o.pattern = this.mainPattern;
			} else {
				o.pattern = this.mainPattern;
				while (o.pattern === this.mainPattern) {
					o.pattern = Pqp.rnd(2);
				}
			}

		} else {
			o.critical = 0;
			o.pattern = this.mainPattern;
		}

		return o;
	}


	createRound(o) {
		this.resetIndicator(o);
		//console.log(o);
		if (this.normal) {
			this.normal.remove();
		}
		if (this.critical) {
			this.critical.remove();
		}
		let normal = jQuery("#template-normal-attack").clone();
		normal.attr("id", "noratt" + AttackWithWeapon.ENUM++);
		normal.css("width", o.normal);
		this.normal = normal;

		let critical = jQuery("#template-critical-attack").clone();
		critical.attr("id", "noratt" + AttackWithWeapon.ENUM++);
		critical.css("width", o.critical);
		this.critical = critical;

		jQuery(".js-hits", this.mc).append(normal);
		jQuery(".js-hits", this.mc).append(critical);

		// a seconda del pattern scelto posiziona normal e critical
		this.commonPattern();
		if (o.pattern === 0) {
			// Sword
			this.patternSword();
		} else if (o.pattern === 1) {
			// Mace combat
			this.patternMaceCombat();
		} else if (o.pattern === 2) {
			// Fencing
			this.patternFencing();
		} else if (o.pattern === 1) {
			// No weapon
			this.patternNoWeapon();
		}

		jQuery(".js-hits", this.mc).css("opacity", 0);
		TweenMax.to(jQuery(".js-hits", this.mc), AttackWithWeapon.TIME_APPEAR_DISAPPEAR_WEAPON, { opacity: 1 });
		TweenMax.to(this.indicator, AttackWithWeapon.TIME_APPEAR_DISAPPEAR_WEAPON, { opacity: 1, onComplete: this.moveIndicator.bind(this, o) });
		jQuery(".js-bar-full", this.mc).width(0);
	}

	commonPattern() {
		let wtot = jQuery(".js-hits", this.mc).width();
		let min = wtot / 3;
		let w = (wtot - min) / 3;
		let wn = this.normal.width();

		let n = Pqp.rnd(2);
		let start = 0;
		//console.log(n)

		if (n === 0) {
			start = Pqp.rnd(start + w - wn, start);
			start += min;

		} else if (n === 1) {
			start = Pqp.rnd(start + w - wn, start) + w;
			start += min;
		} else {
			start = Pqp.rnd(start + w - wn, start) + w + w;
			start += min;
		}

		if (start + wn > wtot) {
			start = wtot - wn - Pqp.rnd(w / 2);
		}

		this.normal.css("left", start);
	}

	patternSword() {
		this.critical.css("left", this.normal.position().left + Math.floor(this.normal.width() - this.critical.width()) / 2);
	}
	patternMaceCombat() {
		this.critical.css("left", this.normal.position().left + this.normal.width() - this.critical.width());
	}
	patternFencing() {
		this.critical.css("left", this.normal.position().left);
	}
	patternNoWeapon() {
		this.critical.hide();
	}

	destroy() {
		jQuery(".js-area-hit", this.ref).off("mousedown");
		jQuery(window).off("keydown.fight");
	}

	resetIndicator(o) {
		jQuery(".js-area-hit", this.ref).off("mousedown");
		jQuery(".js-area-hit", this.ref).on("mousedown", this.userClicked.bind(this, o));

		jQuery(window).off("keydown.fight");
		jQuery(window).on("keydown.fight", this.userPressedKey.bind(this, o));


		jQuery(".js-area-hit", this.ref).hide();

		/*jQuery(".js-click-attack", this.ref).off("mousedown");
		jQuery(".js-click-attack", this.ref).on("mousedown", this.userClicked.bind(this, o));

		jQuery(".js-click-attack", this.ref).css("cursor", "default");*/
		this.indicator.css("left", 0);
		this.indicator.css("opacity", 0);
		jQuery(".js-bar-full", this.mc).width(0);
	}

	moveIndicator(o) {
		this.canClick = true;
		//jQuery(".js-click-attack", this.ref).css("cursor", "pointer");
		jQuery(".js-area-hit", this.ref).show();
		let wtot = jQuery(".js-hits", this.mc).width();
		TweenMax.to(this.indicator, o.time, { left: wtot, ease: Linear.easeNone, onUpdate: this.moveBarFull.bind(this), onComplete: this.userClicked.bind(this, o) });
	}

	moveBarFull() {
		jQuery(".js-bar-full", this.mc).width(this.indicator.position().left + 8);
	}

	userPressedKey(o, e) {
		//console.log("AAAAAAA")
		if ((e.keyCode === Control.FIRE) || (e.keyCode === Control.FIRE_ALT)) {
			this.userClicked(o);
		}
	}


	userClicked(o, e) {
		if (this.canClick) {
			jQuery(".js-area-hit", this.ref).hide();
			this.canClick = false;
			TweenMax.killTweensOf(this.indicator);
			this.checkClick(o);
		}

	}

	checkClick(o) {
		let w = this.indicator.width() / 2;
		let pos = this.indicator.position().left + w;

		if ((pos >= this.critical.position().left) && (pos <= this.critical.position().left + this.critical.width())) {
			// Critico!
			this.criticalHit(o);
		} else if ((pos >= this.normal.position().left) && (pos <= this.normal.position().left + this.normal.width())) {
			// Normale
			this.normalHit(o);
		} else {
			// Missed
			this.missedHit(o);
		}
	}

	criticalHit(o) {
		let pos = (this.indicator.position().left + this.indicator.width() / 2) - this.critical.position().left;
		let w = this.critical.width();
		let mult = 1;
		let damage = Screen.that.paperdoll.getDamageValue()[1];

		if (o.pattern === 0) {
			// Sword (più vicino al centro)
			let block = this.getBlock(w, 3, pos);
			mult = 1.5;
			if (block === 1) {
				mult = 1.75;
			}
		} else if (o.pattern === 1) {
			// Mace (alla fine)
			let block = this.getBlock(w, 3, pos);
			mult = 1.5;
			if (block === 1) {
				mult = 1.75;
			} else if (block === 2) {
				mult = 2;
			}
		} else if (o.pattern === 2) {
			// Fence (all'inizio)
			let block = this.getBlock(w, 3, pos);
			mult = 1.25;
			if (block === 1) {
				mult = 1.5;
			} else if (block === 0) {
				mult = 1.75;
			}
		} else {
			// Punch
			mult = 1;
		}

		damage = Math.floor(damage * mult);
		this.attackDone(Fight.HIT_HIT, damage, true);

	}

	normalHit(o) {
		let pos = (this.indicator.position().left + this.indicator.width() / 2) - this.normal.position().left;
		let w = this.normal.width();
		let mult = 1;
		let damages = Screen.that.paperdoll.getDamageValue();
		let damage = 0;

		if (o.pattern === 0) {
			// Sword (più vicino al centro)
			w -= this.critical.width();
			w = w / 2
			if (pos <= w) {
				// Prima parte
				let block = this.getBlock(w, 5, pos);
				damage = this.calculateDamage(5, block, damages);
			} else {
				// Seconda parte
				let block = this.getBlock(w, 5, pos - this.critical.position().left - this.critical.width() + this.normal.position().left);
				damage = this.calculateDamage(5, 4 - block, damages);
			}
		} else if (o.pattern === 1) {
			// tutto a dx
			let block = this.getBlock(w, 5, pos);
			damage = this.calculateDamage(5, block, damages);

		} else if (o.pattern === 2) {
			// tutto a sx
			let block = this.getBlock(w, 5, pos);
			damage = this.calculateDamage(5, 4 - block, damages);
		} else {
			// a caso
			damage = Pqp.rnd(damages[1], damages[0]);
		}
		this.attackDone(Fight.HIT_HIT, damage, false);
	}

	missedHit(o) {
		this.attackDone(Fight.HIT_MISSED, 0, false);
	}

	getBlock(total, divisor, pos) {
		let slab = total / divisor;
		for (let x = divisor - 1; x >= 0; x--) {
			if (pos >= x * slab) {
				return x;
			}
		}
		return 0;
	}

	calculateDamage(spans, n, damages) {
		let damage = damages[1] - damages[0];
		let segment = damage / spans;
		let segmentDamage = Math.floor(segment * n * 10);
		let nextSegmentDamage = Math.floor(segment * (n + 1) * 10);
		let computedSegmentDamage = Pqp.rnd(nextSegmentDamage, segmentDamage) / 10;
		//console.log("---")
		//console.log(computedSegmentDamage)
		computedSegmentDamage = Math.floor(computedSegmentDamage);
		//console.log(computedSegmentDamage)
		return damages[0] + computedSegmentDamage;
	}




	attackDone(esit, damage, lCritical) {
		//console.log(damage);
		//return;
		let enemy = this.enemy;
		//let a = [Fight.HIT_HIT, Fight.HIT_MISSED, Fight.HIT_PARRIED];
		//let esit = a[Pqp.rnd(a.length - 1)];
		let hp = 0
		//esit = Fight.HIT_HIT;
		if (esit === Fight.HIT_HIT) {
			let item = Screen.that.paperdoll.getCurrentWeapon();
			if (item) {
				let armour = enemy.mob.lore.armour;
				hp = damage - armour;
				if (hp <= 0) {
					hp = 0;
					esit = Fight.HIT_PARRIED;
				}
			} else {
				// no weapon la comunque colpire
				hp = damage;
			}
		}
		this.callback.call(null, { damage: hp, esit: esit, critical: lCritical });
		setTimeout(this.clean.bind(this), 500);
	}

	clean() {
		TweenMax.to(jQuery(".js-hits", this.mc), AttackWithWeapon.TIME_APPEAR_DISAPPEAR_WEAPON, { opacity: 0 });
		TweenMax.to(this.indicator, AttackWithWeapon.TIME_APPEAR_DISAPPEAR_WEAPON, { opacity: 0 });
	}

}

AttackWithWeapon.ENUM = 0;

AttackWithWeapon.TIME_WEAKEST = 1.5;
AttackWithWeapon.TIME_WEAKER = 1.25;
AttackWithWeapon.TIME_EQUAL = 1;
AttackWithWeapon.TIME_STRONGER = 0.75;
AttackWithWeapon.TIME_STRONGESET = 0.5;

AttackWithWeapon.TIME_APPEAR_DISAPPEAR_WEAPON = 0.25;
